import axiosInstance from "../config/axios.config";

export const createOpScaleAPI = (model, payload) => {
  return axiosInstance.post(
    `/scales/generic/?model=${model}`,
    payload
  );
};

export const getOpScaleListAPI = (model, admissionId) => {
  return axiosInstance.get(
    `/scales/generic/`,
    {
      params: {
        model,
        op_admission: admissionId,
      },
    }
  );
};

export const getOpScaleByIdAPI = (model, admissionId, id) => {
  return axiosInstance.get(
    `/scales/generic/`,
    {
      params: {
        model,
        op_admission: admissionId,
        id,
      },
    }
  );
};

export const updateOpScaleAPI = (model, id, payload) => {
  return axiosInstance.put(
    `/scales/generic/${id}/?model=${model}`,
    payload
  );
};
export const getOpProgressScalesCountsAPI = (admissionId) => {
  return axiosInstance.get(
    `/scales/op-progression-scales-counts/${admissionId}/`
  );
};


export const getOpProgressScalesDataAPI = (admissionId, model) => {
  return axiosInstance.get(
    `/scales/op-progression-scales-data/${admissionId}/`,
    {
      params: { model },
    }
  );
};

